import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";

import { API, graphqlOperation } from "aws-amplify";
import {
  aisleByActiveBySortKey,
  areaByActiveBySortKey,
} from "../../../../graphql/reloadyard/custom-queries";

import { makeStyles, Tab, Tabs } from "@material-ui/core";

import { logError } from "../../../../utils/appUtils";
import { AppType } from "../../../../utils/constants";
import { getInitialTab, getLastValueFromUrl } from "../../../../utils/utils";

import Areas from "./Areas";
import Zones from "./Zones";
import Aisles from "./Aisles";
// import Tags from './Tags';

const useStyles = makeStyles((theme) => ({
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    "& span:nth-child(1)": {
      flexDirection: "row",
      justifyContent: "flex-end",
      marginRight: theme.spacing(3),
    },
  },
  tabsContainer: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    width: "100%",
  },
  tabContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
}));

const updateAppUser = (areas, aisles) => {
  if (window.appUser?.appType !== AppType.ADMIN) {
    const areaMap = {};
    window.appUser.reloadYard.areas.items = areas;
    areas.forEach((itm) => (areaMap[itm.id] = itm));
    window.appUser.reloadYard.areaMap = areaMap;

    window.appUser.reloadYard.aisles.items = aisles;
  }
};

const getData = async (record, setAreas, setAisles) => {
  try {
    debugger;
    const areaRsponse = await API.graphql(
      graphqlOperation(areaByActiveBySortKey, {
        reloadYardId: record.id,
        activeSortKey: { beginsWith: { active: "true" } },
        limit: 1000,
      })
    );
    const areas = areaRsponse.data.areaByActiveBySortKey.items;
    areas.forEach((area) => {
      area.zones.items = area.zones.items.filter(
        (itm) => itm.active === "true"
      );
    });
    setAreas(areas);

    // Fetch ALL aisles (paginate)
    let allAisles = [];
    let nextToken = undefined;
    do {
      const input = {
        reloadYardId: record.id,
        activeSortKey: { beginsWith: { active: "true" } },
        limit: 1000,
        ...(nextToken ? { nextToken } : {}),
      };
      const aisleResp = await API.graphql(
        graphqlOperation(aisleByActiveBySortKey, input)
      );
      const items = aisleResp?.data?.aisleByActiveBySortKey?.items;
      allAisles = allAisles.concat(items);
      nextToken = aisleResp?.data?.aisleByActiveBySortKey?.nextToken;
    } while (nextToken);
    setAisles(allAisles);

    updateAppUser(areas, allAisles);
  } catch (err) {
    logError("reloadYard:YardLayout:getData", err, false);
  }
};

export const LayoutTab = ({ record, ...props }) => {
  const myPath = "layout";
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [areas, setAreas] = useState(
    window.appUser?.reloadYard?.areas?.items || []
  );
  const [aisles, setAisles] = useState(
    window.appUser?.reloadYard?.aisles?.items || []
  );
  const [tabValue, setTabValue] = useState(getInitialTab(myPath));
  let tabIndex = 0;

  useEffect(() => {
    const currentPath = getLastValueFromUrl(location.pathname);
    const isTabActive = currentPath === myPath;

    if (isTabActive) {
      history.replace({
        pathname: location.pathname,
        search: `?t=${tabValue}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    history.replace(`${location.pathname}?t=${newValue}`);
  };

  useEffect(() => {
    getData(record, setAreas, setAisles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  const reloadData = async () => {
    await getData(record, setAreas, setAisles);
  };

  return (
    <div className={classes.tabsContainer}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={tabValue}
        onChange={handleTabChange}
        aria-label="Areas Zones Aisles Tabs"
        className={classes.tabs}
      >
        <Tab label="Areas" id="areas" />
        <Tab label="Zones" id="zones" />
        {/* <Tab label="Tags" id="tags" /> */}
        <Tab label="Aisles" id="aisles" />
      </Tabs>
      <TabPanel value={tabValue} index={tabIndex++} classes={classes}>
        <Areas
          record={record}
          areas={areas}
          aisles={aisles}
          getData={reloadData}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={tabIndex++} classes={classes}>
        <Zones
          record={record}
          areas={areas}
          aisles={aisles}
          getData={reloadData}
        />
      </TabPanel>
      {/* <TabPanel value={tabIndexRef.current} index={tabIndex++} classes={classes}>
            <Tags
                record={record}
                areas={areas}
                aisles={aisles}
                getData={reloadData}
            />
        </TabPanel> */}
      <TabPanel value={tabValue} index={tabIndex++} classes={classes}>
        <Aisles
          {...props}
          record={record}
          areas={areas}
          aisles={aisles}
          getData={reloadData}
        />
      </TabPanel>
    </div>
  );
};

const TabPanel = (props) => {
  const { classes, children, value, index, ...other } = props;
  if (value !== index) return null; // Prevent inactive tab content from mounting - not linked to form.pristine

  return (
    <div
      className={classes.tabContent}
      role="tabpanel"
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
};
